import { render } from "./TopMenu.vue?vue&type=template&id=4f477941"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__